import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AccountsService } from '../services/accounts.service';
import { filter, take, switchMap } from 'rxjs/operators';
import { from } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private accountsService: AccountsService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const targetPath = route.routeConfig?.path || '';

    return this.authService.authReady$.pipe(
      filter(ready => ready),
      take(1),
      switchMap(() => {
        return from(this.authService.isAuthenticated());
      }),
      switchMap(async isAuthed => {
        if (!isAuthed) {
          this.router.navigate(['/login']);
          return false;
        }

        // Load account if not already loaded to check trial status
        if (!this.accountsService.currentAccount) {
          await this.accountsService.loadAccount();
        }

        // Trial expiration is now handled by RestrictedAccess mode on the backend
        // which shows paidUpgrade prompts in the chat instead of redirecting
        return true;
      })
    );
  }
}
